import { keys } from "./Help";
import { useStore } from "../../utils/store";
import { useMemo } from "react";

export const DescribedByTargets = () => {
    const status = useStore(s=>s.status)
    const statusKey = useStore(s=>s.statusKey)
    let isMac = useMemo(() => /Mac/.test(navigator.platform), []);
    return(
        <div className="visually-hidden">
            <div id="nav-instructions">
                <ul style={{flexDirection:"column", fontFamily:"Poppins", padding:0, margin:0}}>
                    {keys(isMac).map((k,i)=>
                        <li 
                            style={{width:'100%', display:"flex", flexDirection:"row"}}
                            key={k.key}
                        >
                            <div style={{marginRight:"auto"}}>{k.action}</div>
                            <div style={{marginLeft:100}}>{k.key}</div>
                        </li>
                    )}
                </ul>
            </div>
            <div id="draggable">
                This box can be moved
            </div>
            <div id="non-draggable">
                This box can not be moved
            </div>
            <div id="dropable">
                You can move here
            </div>
            <div id="non-dropable">
                You cannot move here
            </div>
            <div key={statusKey} role="alert" aria-live="assertive">
                <p>
                    {status}
                </p>
            </div>
        </div>
    )
}

export const announce = text => {
    console.log("set status \"" + text + "\"")
    useStore.setState({status: ""})
    setTimeout(()=>{
        useStore.setState({status: text})
    }, 500)
}